import React from 'react';
import {
  Package, UtensilsCrossed, Users, DollarSign, Clock, CheckCircle, ChefHat, Truck,
  TrendingUp, Plus, Edit, Trash2, GripVertical, ArrowUp, ArrowDown, FolderOpen,
  Upload, Image, Star, MessageSquare, Mail, Eye, Reply, Send, Megaphone, Tag, Calendar, X, ChevronLeft
} from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { TabsContent } from '../ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Switch } from '../ui/switch';
import { toast } from 'sonner';
import { apiRequest, formatPrice, getAuthToken } from '../../lib/utils';

const CustomersTab = ({
  customers,
  deleteCustomer,
  orders,
}) => (
          <TabsContent value="customers">
            <div className="space-y-6">
              <Card className="bg-[#141417] border-[#27272A]">
                <CardHeader className="flex flex-row items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <Users className="h-5 w-5 text-[#FFC107]" />
                    Registered Customers ({customers.length})
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {customers.length === 0 ? (
                    <div className="text-center py-12">
                      <Users className="h-12 w-12 text-zinc-700 mx-auto mb-4" />
                      <p className="text-zinc-500">No customers registered yet</p>
                    </div>
                  ) : (
                    <Table>
                      <TableHeader>
                        <TableRow className="border-[#27272A]">
                          <TableHead className="text-zinc-400">Name</TableHead>
                          <TableHead className="text-zinc-400">Email</TableHead>
                          <TableHead className="text-zinc-400">Phone</TableHead>
                          <TableHead className="text-zinc-400">Orders</TableHead>
                          <TableHead className="text-zinc-400">Total Spent</TableHead>
                          <TableHead className="text-zinc-400">Role</TableHead>
                          <TableHead className="text-zinc-400">Joined</TableHead>
                          <TableHead className="text-zinc-400">Actions</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {customers.map((customer) => (
                          <TableRow key={customer.id} className="border-[#27272A]">
                            <TableCell className="font-medium text-white">
                              {customer.name}
                            </TableCell>
                            <TableCell className="text-zinc-300">
                              {customer.email}
                            </TableCell>
                            <TableCell className="text-zinc-300">
                              {customer.phone || '-'}
                            </TableCell>
                            <TableCell>
                              <Badge variant="outline" className="border-zinc-700">
                                {customer.order_count} orders
                              </Badge>
                            </TableCell>
                            <TableCell className="text-[#FFC107] font-medium">
                              {formatPrice(customer.total_spent)}
                            </TableCell>
                            <TableCell>
                              {customer.is_admin ? (
                                <Badge className="bg-[#FFC107]/20 text-[#FFC107]">Admin</Badge>
                              ) : (
                                <Badge variant="outline" className="border-zinc-700 text-zinc-400">Customer</Badge>
                              )}
                            </TableCell>
                            <TableCell className="text-zinc-500 text-sm">
                              {new Date(customer.created_at).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                              })}
                            </TableCell>
                            <TableCell>
                              <Button
                                variant="ghost"
                                size="icon"
                                className="text-red-400 hover:text-red-300 hover:bg-red-500/10 h-8 w-8"
                                onClick={() => deleteCustomer(customer.id, customer.name)}
                                data-testid={`delete-customer-${customer.id}`}
                              >
                                <Trash2 className="h-4 w-4" />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )}
                </CardContent>
              </Card>
            </div>
          </TabsContent>
);

export default CustomersTab;
